import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { FieldOptionUpdateDialogComponent } from 'app/main/content/components/field-option-update-dialog/field-option-update-dialog.component';
import { HelpersService } from 'app/main/content/services/helpers/helpers.service';
import { MatDialog } from '..';

@Component({
  selector: 'app-currency-list',
  templateUrl: './currency-list.component.html',
  styleUrls: ['./currency-list.component.scss']
})
export class CurrencyListComponent implements OnInit {
  
  @Input() translateData: any;
  @Input() field;
  @Output() onFieldValueUpdated: EventEmitter<any> = new EventEmitter();
  @Input() builder;
  @Input() model: any; 
  @Output() modelChange: EventEmitter<any> = new EventEmitter();
  @Output() onError: EventEmitter<any> = new EventEmitter();

  @Input() parentId;
  @Output() parentIdChange: EventEmitter<Object> = new EventEmitter();
  @Input() hideTitle: boolean;
  @Input() formData: any;
  @Output() valChange: EventEmitter<Object> = new EventEmitter();
  
  loading = false;
  error = false;
  errorMessage = '';
  constructor(
    private translationLoader: FuseTranslationLoaderService,
    public dialog: MatDialog,
    
    private changeDetectorRef: ChangeDetectorRef,
    private _helperService: HelpersService

  ) {
    this.model = this.model || '';
  }

  
  ngOnChanges(changes: any) {

    if (changes && changes.translateData && changes.translateData.currentValue) {
      this.translateData = changes.translateData.currentValue;
      this.translationLoader.loadTranslationsV2(this.translateData);    
    }
    console.log("button init - ", this.field);

  }
  editOptions() {
    const dialogRef = this.dialog.open(FieldOptionUpdateDialogComponent, {
      width: '850px',
      height: 'max-content',
      disableClose: true,
      restoreFocus: false,
      data: {
        fieldLabel: this.field.label, 
        formData: this.formData, 
        id: this.field.id, 
        fieldOptions: JSON.parse(JSON.stringify(this.field.options || [])) || [], 
        field: this.field 
      },
      panelClass: 'happ-form-builder-dialog'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.field.options = result;
        this.changeDetectorRef.detectChanges();
      }
    }); 
  }


  getOptions() {
    if (this.field.regId && this.field.optionTitle) {
      this.field.optionTitle = this.field.optionTitle || '';
      const temp: any = this.field.optionTitle.split(',').map((ele) => ({
        prop: ele.trim(),
        title: ele.trim()
      }));

      const cols = [
        ...temp,
        {
          prop: '_id',
          title: '_id'
        }
      ];
      if (this.field.optionValue) {
        cols.push(this.field.optionValue);
      }

      this.loading = true;
      this._helperService.getDataForOptionBasedField(this.field.regId, cols, this.field.hardFilter, this.field.sortBy)
      .then((data) => {
        const tt = [];
        data = data || [];
        data.forEach((ele) => {
          if (this.field.optionValue) {
            tt.push({
              title: temp.map((ele2) => (ele[ele2.prop])).join('-'),
              value: ele[this.field.optionValue],
              _id: ele._id
            });
          } else {
            tt.push({
              title: temp.map((ele2) => (ele[ele2.prop])).join('-'),
              _id: ele._id
            });
          }
        });
        this.field.options = tt || [];
        this.loading = false;
        // this.processValue();
        this.changeDetectorRef.detectChanges();

      }).catch(err => {
        console.info(err);
        this.loading = false;
        this.changeDetectorRef.detectChanges();

      });
    }
    
  }

  objectToString(data: any) {
    if (typeof(data) === 'object') {
      return '';
    } else {
      return data;
    }
  }

  simpleButton(item) {
    if (this.field.saveParentId) {
      this.parentId = item._id;
      this.parentIdChange.next(this.parentId);
    }
    this.model = item.value || item.title; 
    this.onChange(null);
  }

  onChange(name) {
    let val = JSON.parse(JSON.stringify(this.model));
    if (this.field && this.field.typeNumber) {
      this.model = parseFloat(this.model);
    }
    if (name) {
      if (this.field.commaSeperated) {
        const t1 = this.model.split(',').map(ele => ele.trim());
        if (t1.includes(name)) {
          t1.splice(t1.indexOf(name), 1);
        } else {
          t1.push(name);
        }
        val = t1.join(', ');
        this.model = val;
      } else {
        if (typeof(this.model) !== 'object') {
          this.model = {};
        }
        this.model[name] = !this.model[name];
        val[name] = !val[name];
      }
    } 
    this.valChange.emit({
      model: val
    });
    this.modelChange.next(val);
    
    if (this.field['required'] && (this.model === null || this.model === undefined || this.model === '')) {
      this.error = true;
      this.errorMessage = 'ct.field_is_required';
      if (!this.model) {
        this.onError.emit({
          error: true,
          label: this.field['label']
        });
      }
    } else {
      this.errorMessage = '';
      this.error = false;
      this.onError.emit({
        error: false,
        label: this.field['label']
      });
    }
    console.log("button clicked - ", this.field);
    if (this.field.haveRules || true) {
      this.onFieldValueUpdated.emit({
        label: this.field.label,
        value: this.model,
        ruleIndex: this.field.ruleIndex,
        field: this.field
      });
      this.changeDetectorRef.detectChanges();

    }
  }
  
  ngAfterViewInit() {
    this.field = this.field || {};
    this.field.options = [
      {
        "title": "PLN",
        "value": "PLN"
        },
        {
        "title": "EUR",
        "value": "EUR"
        },
        {
        "title": "GBP",
        "value": "GBP"
        },
        {
        "title": "USD",
        "value": "USD"
        },
        {
        "title": "CHF",
        "value": "CHF"
        },
        {
        "title": "AUD",
        "value": "AUD"
        },
        {
        "title": "HUF",
        "value": "HUF"
        },
        {
        "title": "CZK",
        "value": "CZK"
        },
        {
        "title": "UAH",
        "value": "UAH"
        },
        {
        "title": "HRK",
        "value": "HRK"
        },
        {
        "title": "BGN",
        "value": "BGN"
        },
        {
        "title": "RON",
        "value": "RON"
        },
        {
        "title": "RUB",
        "value": "RUB"
        },
        {
        "title": "SEK",
        "value": "SEK"
        }
    ]
    const temp = {};
    if (this.field.multiple) {

      if (this.field.commaSeperated) {
        if (!this.field.userRegister) {
          this.model = this.objectToString(this.model) || '';
          const t1 = this.model.split(',').map((ele) => ele.trim());
          this.field['options'].forEach(element => {
            if (t1.includes(element.value)) {
              temp[element.value] = true;
            } else {
              temp[element.value] = false;
            }
          });
          this.model = temp;
        }
      } else {
        this.field['options'].forEach(element => {
          temp[element.value] = false;
        });
        this.model = (this.model) ? this.model : temp;          
      }
    } else {
      if (typeof(this.model) === 'object') {
        this.model = '';
      } else {
        this.model = this.model || '';
      }
    }
 
  
    if (this.field['preselectedValue'] && this.model && this.model.length === 0){
      this.model = this.field['preselectedValue'];
      this.onChange(null);
    }
  }

  processValue() {
    const temp = {};
    if (this.field.multiple) {

      if (this.field.commaSeperated) {
        this.model = this.objectToString(this.model) || '';
        const t1 = this.model.split(',').map((ele) => ele.trim());
        this.field['options'].forEach(element => {
          if (t1.includes(element.value)) {
            temp[element.value] = true;
          } else {
            temp[element.value] = false;
          }
        });
        this.model = temp;
      } else {
        this.field['options'].forEach(element => {
          temp[element.value] = false;
        });
        this.model = (this.model) ? this.model : temp;          
      }
    }
  }

  ngOnInit() {
    if (this.field.userRegister) {
      this.getOptions();
    }
    this.changeDetectorRef.markForCheck();
    this.translationLoader.loadTranslationsV2(this.translateData);
    if (this.field['required'] && (this.model === null || this.model === undefined || this.model === '')) {
      this.error = true;
      this.errorMessage = 'ct.field_is_required';
      if (!this.model) {
        this.onError.emit({
          error: true,
          label: this.field['label']
        });
      }
    }
  }

  get getLength() {
    if (this.model && typeof(this.model) === 'object') {
      const temp = [];
      Object.keys(this.model).forEach((ele) => {
        if (this.model[ele]) {
          temp.push(ele);
        }
      })
      return temp;
    } else if (this.model && typeof(this.model) === 'string') {
      return this.model.split(',').map(ele => ele.trim());
    }
  }
}
